import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-coaching-commitment-status',
    template: ` <cmps-icon [svgIcon]="icon"></cmps-icon>
        <span class="cmps-coaching-commitment-status--label">{{
            label
        }}</span>`,
    host: {
        class: 'cmps-coaching-commitment-status',
        '[style.backgroundColor]': 'color',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsCommitmentFocusStatusComponent {
    @Input() color: string;
    @Input() icon: string;
    @Input() label: string;
}
